import { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useBasket } from '../context/BasketContext.jsx';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { useStoreUI } from '../context/StoreUIContext.jsx';
import { headUrl } from '../lib/minecraft.js';
import '../styles/components/BottomNavStyle.css';

export function BottomNav() {
  const { categories } = useStoreConfig();
  const { loggedIn, count } = useBasket();
  const { openBasket, openLogin } = useStoreUI();
  const { pathname } = useLocation();
  const strip = useRef(null);


  useEffect(() => {
    const node = strip.current;
    const active = node?.querySelector('.bottom-nav-item.active');

    if (!node || !active) return;


    const centred = active.offsetLeft - (node.clientWidth - active.offsetWidth) / 2;
    const furthest = node.scrollWidth - node.clientWidth;
    const left = Math.max(0, Math.min(centred, furthest));

    if (Math.abs(left - node.scrollLeft) > 1) node.scrollLeft = left;
  }, [pathname, categories]);

  return (
    <nav className="bottom-nav" aria-label="Quick navigation">
      <div className="bottom-nav-scroll" ref={strip}>
        {categories.map((category) => (
          <NavLink
            key={category.id}
            to={`/categories/${category.slug}/`}
            className={({ isActive }) => `bottom-nav-item${isActive ? ' active' : ''}`}
          >
            <span className="bottom-nav-icon">
              {category.icon ? (
                <img
                  src={headUrl(category.icon, 80)}
                  alt=""
                  width="30"
                  height="30"
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <i className="fa-solid fa-cube" />
              )}
            </span>
            <span className="bottom-nav-label">{category.name}</span>
          </NavLink>
        ))}

        <button
          type="button"
          className="bottom-nav-item bottom-nav-basket"
          onClick={() => (loggedIn ? openBasket() : openLogin())}
          aria-label={loggedIn ? 'Open basket' : 'Login to add items'}
        >
          <span className="bottom-nav-icon">
            <i className="fa-solid fa-cart-shopping" />
            <span className="bottom-nav-bubble" hidden={!loggedIn || count <= 0}>
              {count}
            </span>
          </span>
          <span className="bottom-nav-label">Basket</span>
        </button>
      </div>
    </nav>
  );
}
